import { ChangeDetectionStrategy, ChangeDetectorRef, Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';
import { DemandeContratAccueilMentalo } from '@app/models/contrat-accueil';
import { FamilyService, FormConfigService, PermissionService } from '@app/services';
import { PlatformService } from '@app/services/platform.service';
import { filter, map, switchMap, tap } from 'rxjs';

@Component({
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-demande-contrat-accueil',
  templateUrl: './demande-contrat-accueil.component.html',
  styleUrl: './demande-contrat-accueil.component.scss'
})
export class DemandeContratAccueilComponent implements OnInit {

  familyService = inject(FamilyService);
  permService = inject(PermissionService);
  formConfigService = inject(FormConfigService);
  destroyRef: DestroyRef = inject(DestroyRef);
  cdr = inject(ChangeDetectorRef);
  router = inject(Router);
  platformService = inject(PlatformService);

  demandesContrat: DemandeContratAccueilMentalo[];
  demandesFiltered: DemandeContratAccueilMentalo[];
  formStepDemandeContratAccueil: any[];
  permToCreate: boolean;
  readOnly: boolean;
  showDecidedDemandes = false;
  drawerOpened = false;

  ngOnInit(): void {
    this.readOnly = !this.permService.hasPermission('demande_contrat_accueil_edit');
    this.permToCreate = this.permService.hasPermission('demande_contrat_accueil_create');

    this.loadFormSteps().subscribe(steps => this.formStepDemandeContratAccueil = steps);

    this.familyService.currentFamily$.pipe(
      filter(f => !!f),
      takeUntilDestroyed(this.destroyRef),
      tap(() => { this.demandesContrat = null; }),
      switchMap(family => this.familyService.getFamilyInscriptions(family, 'Mentalo'))
    ).subscribe((demandesContrat: DemandeContratAccueilMentalo[]) => {
      this.demandesContrat = demandesContrat;
      this.demandesContrat.forEach(d => {
        d.programmation = Object.entries((d as any).programmation ?? {});
      });
      this.demandesFiltered = this.demandesContrat.filter(d => !this.isDecided(d.decision));
      this.cdr.markForCheck();
    });
  }

  loadFormSteps() {
    return this.formConfigService.getForm('form-demande-contrat-accueil').pipe(
      map(steps => steps.map(step => ({ stepName: step.stepName, label: step.label })))
    );
  }

  openForm(demande: DemandeContratAccueilMentalo, stepName: string) {
    this.router.navigate([`/account/demande-contrat-accueil/edit/${demande.idInscriptionMentalo}/${stepName}`]);
  }

  isDecided(decision: string): boolean {
    return !!decision && decision !== 'En attente';
  }

  toggleShowDecidedDemandes(show: boolean) {
    this.demandesFiltered = show
      ? [...this.demandesContrat]
      : this.demandesContrat.filter(d => !this.isDecided(d.decision));
  }

  closeDrawer() {
    this.drawerOpened = false;
  }

  toggleDemandesOptions() {
    this.drawerOpened = !this.drawerOpened;
    this.cdr.markForCheck();
  }
}
